import { Form, Formik } from 'formik';
import PropTypes from 'prop-types';
import { ImCross } from 'react-icons/im';
import { Col, Row } from 'reactstrap';
import { object, string } from 'yup';
import { Button, Input, ModalComponent } from '../../../common/components';
import { ACTION_EDIT, ACTION_NEW } from '../../../constants/gl-configuration';
import { accountTypeRegex, alphaNumbericWithFourRegex } from '../../../constants/regex';
import AccountTypeDropdown from '../common/AccountTypeDropdown';

const AddSegmentValueModal = ({ isOpen, toggle, action, onSubmit, selectedValue, segment }) => {
  const AddSegmentValue = () => {
    return (
      <div className="add-account-modal">
        <div className="close-btn">
          <ImCross color="#D38529" onClick={toggle} />
        </div>
        <div className="add-modal-header">{`${action} Segment Value`}</div>
        <Formik
          initialValues={{
            segmentValue: selectedValue?.segmentValue || '',
            description: selectedValue?.description || '',
            accountType:
              selectedValue?.accountType && selectedValue?.accountTypeId
                ? {
                    label: selectedValue?.accountType,
                    value: selectedValue?.accountTypeId,
                  }
                : null,
            segment: segment?.value,
          }}
          validationSchema={object({
            description: string()
              .trim()
              .required(`Description is Required`)
              .matches(accountTypeRegex, `Description must be 2 to 60 characters only`),
            segmentValue: string()
              .trim()
              .required(`Segment Value is Required`)
              .matches(
                alphaNumbericWithFourRegex,
                `Segment Value must be 2 to 4 AlphaNumeric characters only`,
              ),
            accountType: string()
              .nullable()
              .trim()
              .when('segment', {
                is: (val) => val === 1,
                then: string().required(`Account Type is Required`),
              }),
          })}
          onSubmit={onSubmit}
        >
          {({ handleSubmit, values, setFieldValue, setFieldTouched }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <div>
                  <Row className="seg-row">
                    <Col lg="6" md="6" sm="6" className="seg-add-inp my-4">
                      <Input
                        formInput
                        required
                        name="segmentValue"
                        className="Account-input"
                        placeholder="Segment Value"
                        value={values?.segmentValue}
                        maxLength={4}
                        disabled={action === ACTION_EDIT}
                      />
                    </Col>
                    {segment?.value === 1 && (
                      <Col
                        lg="6"
                        md="6"
                        sm="6"
                        className="atd-input-segment mt-4 seg-add-md seg-add-inp"
                      >
                        <AccountTypeDropdown
                          dropdownPlaceholder="Account Type"
                          selection={values.accountType}
                          setSelection={(val) => setFieldValue('accountType', val)}
                          disabled={values.segment !== 1}
                          formInput
                          handleSelectFocus={() => {
                            setFieldTouched('accountType', true);
                          }}
                        />
                      </Col>
                    )}
                  </Row>
                  <div className="seg-description my-4">
                    <Input
                      formInput
                      required
                      name="description"
                      maxLength={60}
                      className="Account-input"
                      placeholder="Segment Description"
                      value={values?.description}
                    />
                  </div>
                </div>
                <div className="atd-modal-btns seg-modal-btns">
                  <Button
                    color="primary"
                    className="save-atd-btn"
                    size="xs"
                    type="submit"
                    disabled={
                      action === 'Edit'
                        ? values?.segmentValue === selectedValue?.segmentValue &&
                          (values?.description === selectedValue?.description ||
                            !values?.description) &&
                          (values?.accountType
                            ? values?.accountType?.value === selectedValue?.accountTypeId
                            : !values?.accountType)
                        : (!values.accountType && values.segment === 1) ||
                          !values.segmentValue ||
                          !values.description
                    }
                  >
                    Save
                  </Button>
                  <Button className="cancel-atd-btn" size="xs" onClick={toggle}>
                    Cancel
                  </Button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    );
  };

  return (
    <ModalComponent isOpen={isOpen} toggle={toggle} className="EmailModalWrapper">
      {AddSegmentValue()}
    </ModalComponent>
  );
};

AddSegmentValueModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  action: PropTypes.oneOf([ACTION_NEW, ACTION_EDIT]),
  onSubmit: PropTypes.func.isRequired,
  selectedValue: PropTypes.shape({
    segmentValue: PropTypes.string,
    accountType: PropTypes.string,
    accountTypeId: PropTypes.number,
    description: PropTypes.string,
  }),
  segment: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.number,
  }),
};

AddSegmentValueModal.defaultProps = {
  selectedValue: null,
  action: ACTION_NEW,
  segment: null,
};

export default AddSegmentValueModal;
